// extracted by mini-css-extract-plugin
export var optionGrid = "_2u-7";
export var optionList = "_2u-6";
export var questionsBlock = "_2u-9";
export var spacer = "_2u-5";
export var stepCenteredContent = "_2u-3";
export var stepInner = "_2u-0";
export var stepInnerFullWidth = "_2u-1";
export var stepInnerLockScroll = "_2u-2";
export var stepTransitionFrame = "_2u-4";
export var welcomeBlock = "_2u-8";